import React, { forwardRef, useState, useRef, useImperativeHandle, useEffect } from "react";
import Grid from "@mui/material/Grid";
import PlainTextField from "../InputField/PlainTextField";
import Date from "../InputField/Date";

const ProjectInfo = forwardRef((props, ref) => {
    const [hasError, setHasError] = useState(false);
    const titleRef = useRef();
    const instructionsRef = useRef();
    const addressRef = useRef();
    const cityRef = useRef();
    const stateRef = useRef();
    const zipRef = useRef();
    const dateRef = useRef();
    const today = new window.Date();

    let refs = [titleRef, addressRef, cityRef, stateRef, zipRef, instructionsRef, dateRef];
    const [formValues, setFormValues] = useState(
        props.formData
            ? props.formData
            : {
                  name: "",
                  streetAddress: "",
                  instructions: "",
                  installationDate: "",
                  city: "",
                  state: "",
                  zipcode: "",
              }
    );

    useImperativeHandle(ref, () => ({
        validate() {
            return isValidData();
        },
    }));

    /*const isValidData = () => {
    if (
      formValues?.name != "" &&
      formValues?.name != undefined &&
      formValues?.streetAddress != "" &&
      formValues?.streetAddress != undefined &&
      formValues?.installationDate != "" &&
      formValues?.installationDate != undefined
    ) {
      setHasError(false);
      return !false;
    } else {
      setHasError(true);
      return !true;
    }
  };*/

    const isValidData = () => {
        let hasError = false;

        for (let i = 0; i < refs.length; i++) {
            console.log("projectInfo :: ", refs[i]);
            if (!refs[i].current.validate()) {
                hasError = true;
            }
        }

        setHasError(!hasError);
        return !hasError;
    };
    const handleChange = (id, value) => {
        let newFormValues = { ...formValues };
        newFormValues[id] = value;
        setFormValues(newFormValues);
        props.onChange(newFormValues);
    };

    return (
        <Grid container>
            <Grid item xs={12} md={12}>
                <PlainTextField
                    type="text"
                    ref={titleRef}
                    autoFocus
                    id="name"
                    label="Project Name"
                    placeholder="Let's give your art installation project a friendly name."
                    name="name"
                    margin="normal"
                    isRequired={true}
                    fullWidth
                    multiline={false}
                    minRows={3}
                    maxRows={5}
                    parentHasError={hasError}
                    value={formValues?.name}
                    onChange={(value) => handleChange("name", value)}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <PlainTextField
                    ref={addressRef}
                    id="streetAddress"
                    label="Street Address"
                    placeholder=""
                    name="streetAddress"
                    margin="normal"
                    isRequired={true}
                    fullWidth
                    multiline={false}
                    minRows={3}
                    maxRows={5}
                    value={formValues?.streetAddress}
                    parentHasError={hasError}
                    onChange={(value) => handleChange("streetAddress", value)}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <PlainTextField
                    ref={stateRef}
                    id="state"
                    label="State"
                    placeholder=""
                    name="state"
                    margin="normal"
                    isRequired={true}
                    fullWidth
                    multiline={false}
                    minRows={3}
                    maxRows={5}
                    parentHasError={hasError}
                    value={formValues?.state}
                    onChange={(value) => handleChange("state", value)}
                />
            </Grid>
            <Grid container xs={12} spacing={1}>
                <Grid item xs={12} md={6}>
                    <PlainTextField
                        ref={cityRef}
                        id="city"
                        label="City"
                        placeholder=""
                        name="city"
                        margin="normal"
                        isRequired={true}
                        fullWidth
                        multiline={false}
                        minRows={3}
                        maxRows={5}
                        parentHasError={hasError}
                        value={formValues?.city}
                        onChange={(value) => handleChange("city", value)}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <PlainTextField
                        ref={zipRef}
                        id="zip"
                        label="Zip Code"
                        placeholder=""
                        name="zipcode"
                        margin="normal"
                        isRequired={true}
                        fullWidth
                        multiline={false}
                        minRows={3}
                        maxRows={5}
                        parentHasError={hasError}
                        value={formValues?.zipcode}
                        onChange={(value) => handleChange("zipcode", value)}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
                <PlainTextField
                    ref={instructionsRef}
                    id="instructions"
                    label="Visitor Instructions"
                    placeholder="Does your building have a side entrance, door code, or visitor check-in?"
                    name="instructions"
                    margin="normal"
                    isRequired={false}
                    fullWidth
                    multiline={false}
                    minRows={3}
                    maxRows={5}
                    parentHasError={hasError}
                    value={formValues?.instructions}
                    onChange={(value) => handleChange("instructions", value)}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <Date
                    ref={dateRef}
                    id="installationDate"
                    label="Estimated Installation Date"
                    placeholder="Is there an installation date we should be working towards?"
                    name="installationDate"
                    margin="normal"
                    isRequired={true}
                    fullWidth
                    minDate={today}
                    parentHasError={hasError}
                    value={formValues?.installationDate}
                    onChange={(value) => handleChange("installationDate", value)}
                />
            </Grid>
        </Grid>
    );
});

export { ProjectInfo };
